import { useCallStorage, useCallStoragePvMeta } from '$logic/call'
import { MeetingBar } from '../meeting-bar'
import { ChannelCallBar } from '../channel-call-bar'
import { PvCallBar } from '../pv-call-bar'

export function CallBar({ isInRoom }: { isInRoom?: boolean }) {
  const { callType, roomId: ongoingCallRoomId } = useCallStorage()

  const { roomId: pvCallRoomId } = useCallStoragePvMeta()
  if (pvCallRoomId)
    return <PvCallBar roomId={pvCallRoomId} isInRoom={isInRoom} />

  if (!ongoingCallRoomId) return null
  return callType === 'call' ? (
    <PvCallBar roomId={ongoingCallRoomId} isInRoom={isInRoom} />
  ) : callType === 'group_call' ? (
    <MeetingBar isInRoom={isInRoom} />
  ) : callType === 'live' ||
    callType === 'tribune' ||
    callType === 'classroom' ? (
    <ChannelCallBar isInRoom={isInRoom} callType={callType} />
  ) : null
}

CallBar.defaultProps = {
  isInRoom: false,
}
